export const savebranchAddressAction = payload => ({
    type: 'SAVE_BRANCH_ADDRESS',
    payload
})